/*
 * Lemonade Training Oy copy rights all right reserved.
 * Access Event Contract (F023): client events about access decisions, logged by
 * the logAccessEvent callable. Frozen names; never a uid, programme id or name.
 */

export const ACCESS_EVENTS = Object.freeze({
  /**
   * A programme read was denied by the rules. `expectedAccess: true` means
   * the viewer reached it from their own lane or library, so the denial is
   * a rules bug, not a curious click.
   */
  privateProgrammeDeniedView: "private_programme_denied_view",
} as const);

export type AccessEventName =
  (typeof ACCESS_EVENTS)[keyof typeof ACCESS_EVENTS];

export const ACCESS_EVENT_PLATFORMS = ["web", "mobile"] as const;
export type AccessEventPlatform = (typeof ACCESS_EVENT_PLATFORMS)[number];

export const ACCESS_EVENT_VIEWER_ROLES = [
  "owner",
  "admin",
  "coach",
  "independent_coach",
  "athlete",
  "platform_admin",
] as const;
export type AccessEventViewerRole = (typeof ACCESS_EVENT_VIEWER_ROLES)[number];

export const ACCESS_EVENT_ALLOWED_PROPS = Object.freeze({
  private_programme_denied_view: ["platform", "viewerRole", "expectedAccess"],
} as const satisfies Record<AccessEventName, readonly string[]>);

export type PrivateProgrammeDeniedViewProps = {
  platform: AccessEventPlatform;
  viewerRole: AccessEventViewerRole;
  expectedAccess: boolean;
};
